import { Modal, MuniSpinner2 } from "../../../components";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import { useActasStore } from "../../../store/actasStore";
import { AnimatePresence, motion } from "framer-motion";
import GenerarActa from "../../../screens/Actas/Acta/Proceso/GenerarActa";
import useMeasure from "react-use-measure";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";
import { Alert, Button } from "react-bootstrap";
import React from "react";
import { useActas } from "../../../hooks/useActas";


const ModalImprimirActas = ({ actasAImprimir, setActasAImprimir, setRefetch }) => {

    //? ESTADOS GLOBALES
    const { loads, modals, handlerModal } = useGeneralAppStore();
    const { setActaDetalle } = useActasStore();
    const { imprimirActas } = useActas();
    // const { actaDetalle } = useActaDetalleStore()

    // const { acta } = actaDetalle;
    const [ref, bounds] = useMeasure();
    // console.log(loads)

    return (
        <>
            <Modal
                backdrop={true}
                show={modals.includes('modal_imprimir_actas')}
                size={"lg"}
                onHide={() => handlerModal({ modal: false, modalName: "modal_imprimir_actas" })}
                title={() => "Imprimir Actas"}
            >
                <div className="position-relative">

                    {
                        loads.includes('marcar_impresa') &&
                        <div className="position-absolute h-100 w-100 z-3" style={{ backgroundColor: "rgba(255,255,255,0.7)" }}>
                            <MuniSpinner2 />
                        </div>
                    }
                    <Alert variant="primary">
                        <p className="fs-4 fw-bold">Actas a imprimir</p>
                        <ul className="mb-0">
                            {
                                actasAImprimir.map((acta) => {
                                    return (
                                        <React.Fragment key={acta.id}>
                                            <li className="row  ">
                                                <p className="col-12 col-sm-6 col-md-6 col-lg-3 p-0 m-0 fw-bold">N° de Acta: <span className="fw-normal "> {acta.numero_acta}</span></p>
                                                <p className="col-12 col-sm-6 col-md-6 col-lg-3 p-0 m-0 fw-bold">Fecha: <span className="fw-normal "> {acta.fecha_hora}</span></p>
                                                {
                                                    acta?.documento &&
                                                    <p className="col-12 col-sm-6 col-md-6 col-lg-3 p-0 m-0 fw-bold">DNI: <span className="fw-normal "> {acta.documento}</span></p>
                                                }
                                                {
                                                    acta?.infraccion &&
                                                    <p className="col-12 col-sm-6 col-md-6 col-lg-3 p-0 m-0 fw-bold">Tipo: <span className="fw-normal "> {acta.infraccion}</span></p>
                                                }
                                            </li>
                                            <hr className="m-2" />
                                        </React.Fragment>
                                    )
                                })
                            }
                        </ul>

                    </Alert>

                    <section className="w-100 d-flex justify-content-end gap-2">
                        <Button size="sm" onClick={() => { imprimirActas({ actas: actasAImprimir.map((acta) => acta.id) }, setActasAImprimir, setRefetch) }}>Imprimir</Button>
                        <Button size="sm" variant="danger" onClick={() => handlerModal({ modal: false, modalName: "modal_imprimir_actas" })}>Cancelar</Button>
                    </section>
                    <AnimatePresence>
                        <motion.div animate={{ height: bounds.height }} className="overflow-hidden">
                            estas seguro?
                        </motion.div>
                    </AnimatePresence>
                </div>



            </Modal>
        </>
    );
}
export default ModalImprimirActas;